//#################### Path :: app/scripts/logout.js//####################
function logout() {

    $.ajax({
        url: "/user.php",
        data: {"url-action": "logout"},
        type: "POST"
    }).done(function () {
        window.location = '/login.php';
    });
}


